import { render, staticRenderFns } from "./set_attribute.vue?vue&type=template&id=23408e52&scoped=true&"
import script from "./set_attribute.vue?vue&type=script&lang=js&"
export * from "./set_attribute.vue?vue&type=script&lang=js&"
import style0 from "./set_attribute.vue?vue&type=style&index=0&id=23408e52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23408e52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23408e52')) {
      api.createRecord('23408e52', component.options)
    } else {
      api.reload('23408e52', component.options)
    }
    module.hot.accept("./set_attribute.vue?vue&type=template&id=23408e52&scoped=true&", function () {
      api.rerender('23408e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/product/set_attribute.vue"
export default component.exports